<template>
  <div class="flex h-[100vh] flex-col items-center bg-cyan-50 p-2 pl-10 pr-10">
    <slot />
  </div>
</template>
